import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TcsNavigationService } from 'src/app/shared/tcs-navigation.service';

export enum AppContext {
  Ops = 'Ops',
  Org = 'Org',
  Insights = 'Insights',
  Asb = 'Asb',
  OosRum = 'OosRum',
  Rtt = 'Rtt',
  FleetStatus = 'FleetStatus',
  Support = 'Support',
}

@Injectable({
  providedIn: 'root',
})
export class AppContextService {
  private _currentContext$ = new BehaviorSubject<AppContext>(AppContext.Insights);

  get currentContext$() {
    return this._currentContext$.asObservable();
  }

  constructor(private _tcsNav: TcsNavigationService) {}

  public setContext(context: AppContext | undefined) {
    context != null
      ? this._currentContext$.next(context)
      : this._currentContext$.next(AppContext.Insights);
  }
}
